export const USER_TABLE_COLUMNS = [
    {
        Header: 'Name',
        columns: [
            {
                Header: 'Full',
                accessor: 'title'
            },
            {
                Header: 'First',
                accessor: 'firstName',
            },
            {
                Header: 'Last',
                accessor: 'lastName',
            },
        ],
    },
    {
        Header: 'Info',
        columns: [
            {
                Header: 'Status',
                accessor: 'memberState'
            },
            {
                Header: 'Primary Subsite',
                accessor: 'primarySubsite'
            },
            {
                Header: 'Username',
                accessor: 'username'
            },
            {
                Header: 'Email',
                accessor: 'email'
            }
        ]
    },
    {
        Header: 'IDs',
        columns: [
            {
                Header: 'Object',
                accessor: 'objectId',
            },
            {
                Header: 'Person',
                accessor: 'personId',
            },
            {
                Header: 'User',
                accessor: 'userId',
            },
            {
                Header: 'Party',
                accessor: 'partyId',
            },
            {
                Header: 'Rel',
                accessor: 'relId',
            },
            {
                Header: 'Authority',
                accessor: 'authorityId',
            },
        ],
    },
    {
        Header: 'Dates',
        columns: [
            {
                Header: 'Created',
                accessor: 'creationDate'
            },
            {
                Header: 'Last Modified',
                accessor: 'lastModifiedDate'
            },
            {
                Header: 'Last Visited',
                accessor: 'lastVisitDate'
            },
            {
                Header: 'Password Change',
                accessor: 'passwordChangedDate'
            }
        ]
    }
]